import PropTypes from 'prop-types';
import { memo } from 'react';
import FormattedMessage from 'I18n/components/FormattedMessage';
import UIButton from 'UIComponents/button/UIButton';

// @ts-expect-error ts-migrate(2565) FIXME: Property 'defaultProps' is used before being assig... Remove this comment to see the full error message
import { jsx as _jsx } from "react/jsx-runtime";
function ApplyFiltersButton(props) {
  return /*#__PURE__*/_jsx(UIButton, {
    "data-test-id": "apply-filters-button-internal",
    disabled: props.isDisabled,
    onClick: props.onClick,
    use: "primary",
    children: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "app.filter.panel.applyFilters"
    })
  });
}
ApplyFiltersButton.propTypes = {
  isDisabled: PropTypes.bool,
  onClick: PropTypes.func.isRequired
};
ApplyFiltersButton.defaultProps = {
  isDisabled: false
};
export default /*#__PURE__*/memo(ApplyFiltersButton);